export default __webpack_public_path__ + "static/media/bihorel3.13f077a2.jpg";